//////////////////////////////////////////////////////////////////////////////
// Harmony Learning Maps
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Map configuration including styles and icons
//////////////////////////////////////////////////////////////////////////////
var marker_x_size = 24;
var marker_y_size = 24;
var marker_x_center = 12;
var marker_y_center = 12;
var mapdiv = document.querySelector('.js-centres-map');

const mapConfig = {
  styles: [{"featureType":"all","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"gamma":0.01},{"lightness":20}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"saturation":-31},{"lightness":-33},{"weight":2},{"gamma":0.8}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#2d2828"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"lightness":30},{"saturation":30}]},{"featureType":"poi","elementType":"geometry","stylers":[{"saturation":20}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"lightness":20},{"saturation":-20}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":10},{"saturation":-30}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"saturation":25},{"lightness":25}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#2d2828"}]},{"featureType":"water","elementType":"all","stylers":[{"lightness":-20}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"color":"#ffffff"}]}],
  icons: {
    active: '/wp-content/themes/bryantbuildingcontractors/assets/img/mapicon-active.png',
    inactive: '/wp-content/themes/bryantbuildingcontractors/assets/img/mapicon-inactive.png'
  },
  radius: 15000, // 15 kilometers radius
  enableDebugPins: false, // Toggle for debug pins
  enableOffset: true, // Toggle for map offsetting
  mapBoundsOffset: Math.min(mapdiv.offsetWidth, mapdiv.offsetHeight) * 0.07,
  offsetDirection: 'right', // Offset direction ('left' or 'right')
  mediaQueryBreakpoints: {
    576: false, // Disable offset at screen widths >= 576px (sm and below).
    768: false,  // Enable offset at screen widths >= 768px (md).
    992: true,  // Enable offset at screen widths >= 992px (lg).
    1200: true, // Enable offset at screen widths >= 1200px (xl).
    1400: true  // Enable offset at screen widths >= 1400px (xxl).
  },
  // Configuration for the Google Places Autocomplete search box
  placeSearchOptions: {
    // Restrict the autocomplete search to only show region-level results
    types: ['(regions)'], // Restrict the search to regions (localities, suburbs). Can be a single type or an array of types (e.g., '(regions)', 'geocode', 'address', 'establishment', '(cities)')

    // Restrict the autocomplete results to a specific country
    componentRestrictions: {
      country: 'au' // Restrict results to Australia. Can be an array of country codes (e.g., ['us', 'ca'] for the United States and Canada).
    }
  },
  debug: false, // Add this line to enable/disable debug logging
  clustering: {
    enabled: true
  },
  persistActive: true, // persist active marker/list item
  keepActiveInList: true, // keep active list when active marker goes out of bound
  markerCenterOnClick: false, // prevent markers from centering on click
  mapHint: {
    enabled: !!document.querySelector('.js-map-hint'),
    delay: 10000
  },
};



//////////////////////////////////////////////////////////////////////////////
// Declare map variables in global scope
//////////////////////////////////////////////////////////////////////////////
var map;
let isUsingLocation = false;
let currentActiveMarker = null;
let debugPins = [];
let placeSearch;
let markersObject = [];
let markerClusterer = null;
let activeCentreId = null;
let isClusterZooming = false;
let isUserInteracting = false;
const isProjectsPage = document.body.classList.contains('page-template-template-projects');
const isMobile = window.innerWidth < 992;

//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Initialise functions
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Initialise the map
// This function initializes the Google Map, sets up the map configuration,
// and adds event listeners for various map interactions including resizing.
//////////////////////////////////////////////////////////////////////////////
function initMap() {
  // Initial center coordinates and zoom level for the map (Brisbane)
  const initialCenter = { lat: -27.3817412, lng: 152.8283958 };
  const initialZoom = 14;

  // Create a new Google Map instance
  map = new google.maps.Map(document.querySelector('.js-centres-map'), {
    zoom: initialZoom,
    center: initialCenter,
    styles: mapConfig.styles,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    scaleControl: false,
    rotateControl: false,
    zoomControl: true,
    gestureHandling: mapConfig.mapHint.enabled ? 'greedy' : 'cooperative'
  });

  // Adjust the initial center to shift markers to the right half of the map
  google.maps.event.addListenerOnce(map, 'bounds_changed', adjustMapCenter);

  // Initialise the Autocomplete for places search
  const input = document.querySelector('.js-place-search');
  placeSearch = new google.maps.places.Autocomplete(input, mapConfig.placeSearchOptions);
  placeSearch.addListener('place_changed', handlePlacesChanged);

  // Listen for the enter key press on the search input field
  input.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default form submission
      const query = input.value; // Get the value from the input field
      performSearch(query); // Perform the search with the user input
    }
  });

  // Create an InfoWindow for displaying information
  const infoWindow = new google.maps.InfoWindow();

  // Sort centres alphabetically for the initial load
  const sortedCentres = [...mapData.centres].sort((a, b) => a.title.localeCompare(b.title));

  // Create a LatLngBounds instance to fit the map to the markers
  const bounds = new google.maps.LatLngBounds();

  // Iterate through the sorted centres data and create markers
  sortedCentres.forEach(centre => {
    createMarker(centre, infoWindow, bounds);
  });

  createMarkerClustering();

  // Adjust the map to fit the bounds of the markers
  // map.fitBounds(bounds, mapConfig.mapBoundsOffset);
  fitBoundsTight(bounds);

  // Add event listeners for map interactions
  google.maps.event.addListener(map, 'bounds_changed', resetLocationButton);
  //google.maps.event.addListener(map, 'dragend', updateVisibleCentres); // Update centres on drag end
  //google.maps.event.addListener(map, 'zoom_changed', updateVisibleCentres); // Update centres on zoom change

  google.maps.event.addListener(map, 'dragstart', () => {
    isUserInteracting = true;
  });

  google.maps.event.addListener(map, 'idle', () => {
    // small delay so updateVisibleCentres finishes first
    setTimeout(() => {
      isUserInteracting = false;
    }, 100);
    //drawBoundsOverlay();
  });

  // Adjust the map center on window resize
  let resizeTimeout;
  let lastWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const bounds = new google.maps.LatLngBounds();

        // Sort centres alphabetically
        const sortedCentres = [...mapData.centres].sort((a, b) => a.title.localeCompare(b.title));

        // Clear the centres list
        updateCentreList([]);

        // Iterate through the sorted centres data and update markers and bounds
        sortedCentres.forEach(centre => {
          if (centre.marker && centre.marker.getMap() === map) {
            bounds.extend(centre.marker.getPosition());
          }
        });

        // Fit the map to the new bounds
        // map.fitBounds(bounds, mapConfig.mapBoundsOffset);
        fitBoundsTight(bounds);
        adjustMapCenter();

        // Update the centres list with sorted centres
        updateCentreList(sortedCentres);
      }, 100);
    }
  });

  // Initialise search from query string if present
  setTimeout(initSearchFromQuery, 1000);

  // Update centre list with sorted centres after a slight delay
  setTimeout(() => {
    updateCentreList(sortedCentres);
    
    if(isProjectsPage){
      handleViewAllLocations();
      if(isMobile){ 
        adjustMapCenter(8);
      }
    }else{
      if(!isMobile){ 
        map.setZoom(map.getZoom() - 0.50); 
      }else{
        adjustMapCenter(-4.5);
      }
    }
  }, 400);

  console.log(mapdiv.getBoundingClientRect());


//////////////////////////////////////////////
// Custom Hint Overlay
//////////////////////////////////////////////
if (mapConfig.mapHint?.enabled) {

  const $wrapper = mapdiv.closest('.centres-map-wrapper-col');
  const $hint = $wrapper ? $wrapper.querySelector('.js-map-hint') : null;

  if (!$hint) {
    console.warn('Map hint not found');
  } else {

    let inactivityTimer = null;
    const INACTIVITY_DELAY = mapConfig.mapHint.delay || 10000;
    let allowInteraction = false;

    setTimeout(() => {
      $hint.classList.add('is-visible');

      setTimeout(() => {
        allowInteraction = true;
      }, 500);

    }, 50);

    function showMapHint() {
      if (!$hint.classList.contains('is-visible')) {
        $hint.classList.add('is-visible');
      }
    }

    function hideMapHint() {
      if ($hint.classList.contains('is-visible')) {
        $hint.classList.remove('is-visible');
      }
    }

    function resetInactivityTimer() {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(showMapHint, INACTIVITY_DELAY);
    }

    function handleUserInteraction() {
      if (!allowInteraction) return;

      hideMapHint();
      resetInactivityTimer();
    }

    mapdiv.addEventListener('wheel', handleUserInteraction, { passive: true });
    mapdiv.addEventListener('mousedown', handleUserInteraction);
    mapdiv.addEventListener('touchstart', handleUserInteraction);
    mapdiv.addEventListener('pointerdown', handleUserInteraction);

  }
}





}


function fitBoundsTight(bounds) {
  map.fitBounds(bounds, mapConfig.mapBoundsOffset);
  google.maps.event.addListenerOnce(map, 'idle', function () {
    if (mapdiv && mapdiv.classList.contains('project')) {
      map.setZoom(map.getZoom() + 0.60);
    }
    setTimeout(() => {mapdiv.style.opacity = '1';}, 1000);
  });
}

//////////////////////////////////////////////////////////////////////////////
// Check if Google Maps API is loaded and initialise the map
// This function checks if the Google Maps API is loaded and, if so,
// initialises the map. If the API is not loaded, it retries every second.
//////////////////////////////////////////////////////////////////////////////
function checkGoogleMaps() {
  // Check if the Google Maps API is available
  if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
    // Google Maps API is loaded, initialise the map
    initMap();
  } else {
    // Google Maps API is not loaded, retry after a delay
    // Retry every second to check if the Google Maps API is loaded
    // console.error('Google Maps API is not loaded, retrying...');
    setTimeout(checkGoogleMaps, 1000);
  }
}

//////////////////////////////////////////////////////////////////////////////
// Initialise DOM-dependent functionality
// This function sets up event listeners for DOM elements and checks if the
// Google Maps API is loaded once the DOM content is fully loaded.
//////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function() {
  
  // Add click event listener to the "Use My Location" button
  document.querySelector('.js-use-my-location').addEventListener('click', handleUseMyLocation);

  // Add click event listener to the "View All Locations" button
  document.querySelector('.js-view-all-locations').addEventListener('click', handleViewAllLocations);

  // Add keypress event listener for the "Enter" key on the search input
  document.querySelector('.js-place-search').addEventListener('keypress', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const query = this.value;
      performSearch(query);
    }
  });

  // Add click event listener for the submit button
  document.querySelector('.js-place-search-submit').addEventListener('click', function(event) {
    event.preventDefault();
    const query = document.querySelector('.js-place-search').value;
    performSearch(query);
  });

  // Check if Google Maps API is loaded and initialise the map
  checkGoogleMaps();

  // Set dynamic height on page load
  setTimeout(function(){
    setDynamicHeight();
  },800);

  // Update dynamic height on window resize
  window.addEventListener('resize', setDynamicHeight);
});


//////////////////////////////////////////////////////////////////////////////
// Parse query string and initialise search if present
//////////////////////////////////////////////////////////////////////////////
function initSearchFromQuery() {
  // Get URL search parameters
  const urlParams = new URLSearchParams(window.location.search);
  // Retrieve the 'centre_search' parameter value
  const query = urlParams.get('centre_search');
  debugLog("Query from URL:", query);

  // If the query is "all", handle the view all locations logic
  if (query === 'all') {
    handleViewAllLocations();
    setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
  } else if (query) {
    // Get the search input element
    const searchInput = document.querySelector('.js-place-search');
    // Set the input value to the search query
    searchInput.value = query;
    debugLog("Search input value set to:", searchInput.value);

    // Initialise the Google Places Autocomplete with the input element
    const placeSearch = new google.maps.places.Autocomplete(searchInput, mapConfig.placeSearchOptions);
    debugLog("Autocomplete instance created:", placeSearch);

    // Add an event listener to handle place changes
    placeSearch.addListener('place_changed', handlePlacesChanged);

    // Trigger a simulated search to update the map based on the query
    const service = new google.maps.places.PlacesService(map);
    service.textSearch({ query: query }, function(results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        debugLog("PlacesService textSearch results:", results);
        // Set the input value to the first search result's formatted address
        searchInput.value = results[0].formatted_address;
        debugLog("Search input value updated to first result's address:", searchInput.value);

        // Manually set the place details to the Autocomplete instance
        placeSearch.set('place', results[0]);

        // Manually trigger the place_changed event
        google.maps.event.trigger(searchInput, 'place_changed');
      } else {
        console.log("PlacesService textSearch failed with status:", status);
      }
      // Scroll smoothly to the map section after the map updates
      setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
    });

    // Update display and class on .js-centres-list and .js-centres-listing-wrapper
    document.querySelector('.js-centres-list').style.display = 'block';
    document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

    // Set dynamic height after updating the display
    setDynamicHeight();
  }
}




//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Event Handlers
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Handle places changed event for the Autocomplete
//////////////////////////////////////////////////////////////////////////////
function handlePlacesChanged() {
  debugLog("Using handlePlacesChanged()");
  debugLog("Autocomplete instance:", this);

  // Get the place from the Autocomplete
  const place = this.getPlace();
  debugLog("Place selected from Autocomplete:", place);

  if (!place.geometry) {
    console.log("Returned place contains no geometry");
    return;
  }

  // Initialise bounds for the new map view
  const bounds = new google.maps.LatLngBounds();

  // Get the user's selected location and create bounds around it
  const userLocation = place.geometry.location;
  const userBounds = new google.maps.Circle({
    center: userLocation,
    radius: mapConfig.radius
  }).getBounds();

  // Clear existing list of centres and reset scroll position
  const centresList = document.querySelector('.js-centres-list');
  centresList.innerHTML = '';
  centresList.scrollTop = 0;

  // Reset the active marker and remove active class from the list
  resetActiveMarker();
  clearDebugPins(); // Clear debug pins

  // Remove existing markers from the map
  clearAllMarkers();

  if (markerClusterer) {
    markerClusterer.clearMarkers();
  }

  // Collect centres within the bounds and calculate their distances from the user location
  const centresWithinBounds = mapData.centres
    .map(centre => {
      const position = new google.maps.LatLng(centre.lat, centre.lng);
      const distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, position);
      return { ...centre, distance };
    })
    .filter(centre => userBounds.contains(new google.maps.LatLng(centre.lat, centre.lng)));

  // Sort centres by distance from the user location
  centresWithinBounds.sort((a, b) => a.distance - b.distance);

  // Create markers for the sorted centres and extend the map bounds to include them
  centresWithinBounds.forEach(centre => {
    const position = new google.maps.LatLng(centre.lat, centre.lng);
    bounds.extend(position);
    createMarker(centre, null, bounds);
  });

  refreshMarkerClustering();

  // Add a debug pin for the searched location
  if (mapConfig.enableDebugPins) {
    createDebugPin(userLocation, mapConfig.icons.debugSearched);
  }

  // Extend the bounds to include the user location for correct fit
  bounds.extend(userLocation);

  // Adjust the map to fit the new bounds
  // map.fitBounds(bounds, mapConfig.mapBoundsOffset);
  fitBoundsTight(bounds);

  // Adjust the map center if offsetting is enabled
  if (mapConfig.enableOffset) {
    setTimeout(() => {
      adjustMapCenter(4);
    }, 400); // small delay fixes it
  }

  // Update the centres list with sorted centres
  updateCentreList(centresWithinBounds);

  // Update display and class on .js-centres-list and .js-centres-listing-wrapper
  document.querySelector('.js-centres-list').style.display = 'block';
  document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

  // Set dynamic height after updating the display
  setDynamicHeight();
}

//////////////////////////////////////////////////////////////////////////////
// Perform search based on user input
// This function is triggered when the user presses enter in the search box.
//////////////////////////////////////////////////////////////////////////////
function performSearch(query) {
  const service = new google.maps.places.PlacesService(map);

  // Perform a text search using Google Places API
  service.textSearch({ query: query }, function(results, status) {
    if (status === google.maps.places.PlacesServiceStatus.OK) {
      debugLog("Text search results:", results);

      // Set the input value to the first result's formatted address
      const input = document.querySelector('.js-place-search');
      input.value = results[0].formatted_address;

      // Manually set the place details to the existing Autocomplete instance
      placeSearch.set('place', results[0]);

      // Manually trigger the place_changed event
      google.maps.event.trigger(input, 'place_changed');
    } else {
      console.log("Text search failed with status:", status);
    }
  });
}

//////////////////////////////////////////////////////////////////////////////
// Handle "Use My Location" functionality
//////////////////////////////////////////////////////////////////////////////
function handleUseMyLocation() {
  // Select DOM elements
  const locationStatus = document.querySelector('.js-location-status');
  const locationLoading = document.querySelector('.js-location-loading');
  const useMyLocation = document.querySelector('.js-use-my-location');
  const centresList = document.querySelector('.js-centres-list');
  const searchInput = document.querySelector('.js-place-search');

  // Clear the search input
  searchInput.value = '';

  // Remove the "centre_search" parameter from the URL
  const url = new URL(window.location);
  url.searchParams.delete('centre_search');
  window.history.replaceState({}, '', url);

  // Show loading indicator and hide status and button
  locationLoading.style.display = 'block';
  useMyLocation.style.display = 'none';
  locationStatus.style.display = 'none';

  // Check if geolocation is supported
  if (navigator.geolocation) {
    isUsingLocation = true; // Set the flag for location usage
    navigator.geolocation.getCurrentPosition(position => {
      // Get the user's location
      const userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
      const userBounds = new google.maps.Circle({
        center: userLocation,
        radius: mapConfig.radius
      }).getBounds();

      const bounds = new google.maps.LatLngBounds();

      // Clear existing list and reset scroll position
      centresList.innerHTML = '';
      centresList.scrollTop = 0;

      // Reset the active marker and remove active class
      resetActiveMarker();
      clearDebugPins(); // Clear debug pins

      clearAllMarkers();

      // Collect centres within the bounds and calculate their distances
      const centresWithinBounds = mapData.centres
        .map(centre => {
          const position = new google.maps.LatLng(centre.lat, centre.lng);
          const distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, position);
          return { ...centre, distance };
        })
        .filter(centre => userBounds.contains(new google.maps.LatLng(centre.lat, centre.lng)));

      // Sort centres by distance from the user's location
      centresWithinBounds.sort((a, b) => a.distance - b.distance);

      // Create markers for the sorted centres and extend the map bounds to include them
      centresWithinBounds.forEach(centre => {
        const position = new google.maps.LatLng(centre.lat, centre.lng);
        bounds.extend(position);
        createMarker(centre, null, bounds);
      });

      refreshMarkerClustering();

      // Create debug pin for "Use My Location" if enabled
      if (mapConfig.enableDebugPins) {
        createDebugPin(userLocation, mapConfig.icons.debugLocation);
      }

      // Adjust the map to fit the new bounds
      //map.fitBounds(bounds, mapConfig.mapBoundsOffset);
      fitBoundsTight(bounds);
      
      adjustMapCenter();
      locationLoading.style.display = 'none'; // Hide loading indicator
      locationStatus.style.display = 'block'; // Show location status

      // Delay unsetting the flag to ensure the status remains visible
      setTimeout(() => {
        isUsingLocation = false;
      }, 1000);

      // Update display and class on .js-centres-list and .js-centres-listing-wrapper
      centresList.style.display = 'block';
      document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

      // Set dynamic height after updating the display
      setDynamicHeight();

    }, () => {
      // Handle error when unable to retrieve location
      locationLoading.style.display = 'none';
      useMyLocation.style.display = 'block';
      alert("Unable to retrieve your location.");
      isUsingLocation = false; // Unset the flag
    });
  } else {
    // Handle case when geolocation is not supported
    locationLoading.style.display = 'none';
    useMyLocation.style.display = 'block';
    alert("Geolocation is not supported by this browser.");
    isUsingLocation = false; // Unset the flag
  }
}

//////////////////////////////////////////////////////////////////////////////
// Handle "View All Locations" functionality
// This function handles the event when the "View All Locations" button is clicked.
// It clears the search input, removes the "centre_search" parameter from the URL,
// and updates the map and centre list to show all locations in alphabetical order.
//////////////////////////////////////////////////////////////////////////////
function handleViewAllLocations() {
  // Get references to the centres list and search input elements
  const centresList = document.querySelector('.js-centres-list');
  const searchInput = document.querySelector('.js-place-search');

  // Clear the search input
  searchInput.value = '';

  // Remove the "centre_search" parameter from the URL
  const url = new URL(window.location);
  url.searchParams.delete('centre_search');
  window.history.replaceState({}, '', url);

  // Clear existing list of centres and scroll to the top
  centresList.innerHTML = '';
  centresList.scrollTop = 0;

  // Reset the active marker and remove active class from list items
  resetActiveMarker();
  clearDebugPins(); // Clear debug pins

  // Create a LatLngBounds instance to fit the map to the markers
  const bounds = new google.maps.LatLngBounds();

  clearAllMarkers();

  // Sort centres alphabetically for displaying all locations
  const sortedCentres = [...mapData.centres].sort((a, b) => a.title.localeCompare(b.title));

  // Iterate through the sorted centres data and create markers
  sortedCentres.forEach(centre => {
    createMarker(centre, new google.maps.InfoWindow(), bounds);
  });

  refreshMarkerClustering();

  // Adjust the map to fit the bounds of the markers
  // map.fitBounds(bounds, mapConfig.mapBoundsOffset);
  fitBoundsTight(bounds);

    setTimeout(() => {
      adjustMapCenter(isMobile ? -8 : 4);
      map.setZoom(map.getZoom() - 0.50);
    }, 400); // small delay fixes it

    setTimeout(() => {
      // Update centre list with sorted centres
      updateCentreList(sortedCentres);
    }, 300);

  // Update display and class on .js-centres-list and .js-centres-listing-wrapper
  centresList.style.display = 'block';
  document.querySelector('.js-centres-listing-wrapper').classList.add('h-100');

  // Set dynamic height after updating the display
  setDynamicHeight();

  // Scroll smoothly to the map section after updating the display
  // setTimeout(scrollToMapSection, 500); // Adjust timeout as necessary
}

//////////////////////////////////////////////////////////////////////////////
// Set the active marker
// This function sets a given marker as the active marker, changing its appearance,
// and ensuring the associated list item is highlighted. It also repositions the map
// if necessary to keep the marker within the visible bounds.
//////////////////////////////////////////////////////////////////////////////
function setActiveMarker(activeMarker) {
  // Reset the previous active marker to inactive state
  if (currentActiveMarker) {
    currentActiveMarker.setIcon({
      url: mapConfig.icons.inactive, // Set inactive icon
      scaledSize: new google.maps.Size(24, 24), // Size of the inactive icon
      anchor: new google.maps.Point(marker_x_center, marker_y_center)
    });
    currentActiveMarker.setZIndex(null); // Reset zIndex of previous active marker

    // Remove the active class from the previous list item
    const prevActiveListItem = document.querySelector('.js-centres-list .list-group-item.active');
    if (prevActiveListItem) {
      prevActiveListItem.classList.remove('active');
    }
  }

  // Set the new marker to active state
  activeMarker.setIcon({
    url: mapConfig.icons.active, // Set active icon
    scaledSize: new google.maps.Size(24, 24), // Size of the active icon
    anchor: new google.maps.Point(marker_x_center, marker_y_center)
  });
  activeMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1); // Bring the marker to the front

  // Ensure the marker is within the right 50% of the map
  const mapBounds = map.getBounds();
  const mapCenter = map.getCenter();
  const mapSpan = mapBounds.toSpan();

  const markerPosition = activeMarker.getPosition();
  const rightBoundaryLng = mapCenter.lng() + mapSpan.lng() / 4; // Define the right 50% boundary

  if (mapConfig.markerCenterOnClick && markerPosition.lng() > rightBoundaryLng || !mapBounds.contains(markerPosition)) {
    // Calculate the new center point to shift the marker to the right 50%
    const newCenter = {
      lat: markerPosition.lat(),
      lng: markerPosition.lng() - mapSpan.lng() / 4
    };
    map.panTo(newCenter);
  }

  // Add the active class to the corresponding list item
  const activeListItem = document.querySelector(`.js-centres-list a[data-centre-id="${activeMarker.centreId}"]`);
  if (activeListItem) {
    activeListItem.classList.add('active');
  }

  // Update display and class on .js-centres-list and .js-centres-listing-wrapper
  const centresList = document.querySelector('.js-centres-list');
  const centreListingWrapper = document.querySelector('.js-centres-listing-wrapper');
  if (centresList.style.display !== 'block' || !centreListingWrapper.classList.contains('h-100')) {
    centresList.style.display = 'block';
    centreListingWrapper.classList.add('h-100');
  }

  // Update the current active marker reference
  currentActiveMarker = activeMarker;
  if (mapConfig.persistActive) {
    activeCentreId = activeMarker.centreId;
  }
}

//////////////////////////////////////////////////////////////////////////////
// Reset the active marker and remove active class from list items
// This function resets the currently active marker to its inactive state
// and removes the active class from the corresponding list item.
//////////////////////////////////////////////////////////////////////////////
function resetActiveMarker() {
  if (currentActiveMarker) {
    // Set the current active marker to inactive state
    currentActiveMarker.setIcon({
      url: mapConfig.icons.inactive, // Set inactive icon
      scaledSize: new google.maps.Size(24, 24), // Sise of the inactive icon
      anchor: new google.maps.Point(marker_x_center, marker_y_center)
    });
    currentActiveMarker.setZIndex(null); // Reset zIndex of the active marker
    currentActiveMarker = null; // Clear the reference to the active marker
  }

  // Remove the active class from the previously active list item
  const prevActiveListItem = document.querySelector('.js-centres-list .list-group-item.active');
  if (prevActiveListItem) {
    prevActiveListItem.classList.remove('active');
  }
  if (mapConfig.persistActive) {
    activeCentreId = null;
  }
}

//////////////////////////////////////////////////////////////////////////////
// Revert back to "Use My Location" on map interaction
// This function resets the UI elements related to the "Use My Location"
// functionality if the user is not currently using the location feature.
//////////////////////////////////////////////////////////////////////////////
function resetLocationButton() {
  // Check if the user is not currently using the location feature
  if (!isUsingLocation) {
    // Hide the location status element
    document.querySelector('.js-location-status').style.display = 'none';

    // Hide the location loading indicator
    document.querySelector('.js-location-loading').style.display = 'none';

    // Show the "Use My Location" button
    document.querySelector('.js-use-my-location').style.display = 'block';
  }
}

//////////////////////////////////////////////////////////////////////////////
// Update the visible centres based on map bounds
//////////////////////////////////////////////////////////////////////////////
function updateVisibleCentres() {
  const bounds = map.getBounds();
  const centresList = document.querySelector('.js-centres-list');
  centresList.innerHTML = '';
  centresList.scrollTop = 0; // Scroll to the top

  // Collect visible centres
  // const visibleCentres = mapData.centres.filter(centre =>
    // centre.marker && bounds.contains(centre.marker.getPosition())
  // );
  const visibleCentres = [...mapData.centres];

  if (
    mapConfig.keepActiveInList &&
    mapConfig.persistActive &&
    activeCentreId
  ) {
    const alreadyIncluded = visibleCentres.some(c => c.id == activeCentreId);

    if (!alreadyIncluded) {
      const activeCentre = mapData.centres.find(c => c.id == activeCentreId);

      if (activeCentre) {
        visibleCentres.unshift(activeCentre); // add to top
      }
    }
  }

  // Sort visible centres by proximity to the current map center
  const mapCenter = map.getCenter();
  visibleCentres.sort((a, b) => {
    if (mapConfig.keepActiveInList && a.id == activeCentreId) return -1;
    if (mapConfig.keepActiveInList && b.id == activeCentreId) return 1;

    const distanceA = google.maps.geometry.spherical.computeDistanceBetween(mapCenter, a.marker.getPosition());
    const distanceB = google.maps.geometry.spherical.computeDistanceBetween(mapCenter, b.marker.getPosition());
    return distanceA - distanceB;
  });

  // Add visible centres to the list
  visibleCentres.forEach(centre => addCentreToList(centre, centre.marker));

  if (
    mapConfig.persistActive &&
    activeCentreId &&
    !isClusterZooming &&
    !isUserInteracting
  ) {
    const activeCentre = mapData.centres.find(c => c.id == activeCentreId);

    if (activeCentre && activeCentre.marker) {
      setActiveMarker(activeCentre.marker);
    }
  }

}




//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Utility Functions
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
// Debug log function
//////////////////////////////////////////////////////////////////////////////
function debugLog(...args) {
  if (mapConfig.debug) {
    console.log(...args);
  }
}
//////////////////////////////////////////////////////////////////////////////
// Set dynamic height for .js-centres-list
// This function calculates and sets the dynamic height for the centres list
// based on the available height within the listing wrapper and search elements,
// taking into account the padding adjustments.
//////////////////////////////////////////////////////////////////////////////
function setDynamicHeight() {
  const centresListingColumn = document.querySelector('.js-centres-listing-column');
  const centresListingWrapper = document.querySelector('.js-centres-listing-wrapper');
  const centresSearch = document.querySelector('.js-centres-search');
  const centresList = document.querySelector('.js-centres-list');

  if (centresListingColumn && centresListingWrapper && centresSearch && centresList) {
    // Calculate the padding of the listing column
    const columnStyle = window.getComputedStyle(centresListingColumn);
    const columnPaddingTop = parseFloat(columnStyle.paddingTop);
    const columnPaddingBottom = parseFloat(columnStyle.paddingBottom);
    let columnTotalPadding = columnPaddingTop + columnPaddingBottom;
    if (window.innerWidth < 992) {
      columnTotalPadding = columnTotalPadding + 40;
    }

    // Calculate 25% of the total padding
    const paddingAdjustment = columnTotalPadding * 0.40;
    

    // Calculate the padding of the listing wrapper
    const wrapperStyle = window.getComputedStyle(centresListingWrapper);
    const paddingTop = parseFloat(wrapperStyle.paddingTop);
    const paddingBottom = parseFloat(wrapperStyle.paddingBottom);
    const totalPadding = paddingTop + paddingBottom;

    // Calculate available height considering the padding and subtracting the padding adjustment
    const availableHeight = centresListingWrapper.clientHeight - centresSearch.clientHeight - totalPadding - paddingAdjustment;

    // Ensure availableHeight is not negative
    const finalHeight = Math.max(availableHeight, 0);

    // Log the calculated values for debugging
    debugLog('Column Padding Top:', columnPaddingTop);
    debugLog('Column Padding Bottom:', columnPaddingBottom);
    debugLog('Column Total Padding:', columnTotalPadding);
    debugLog('Padding Adjustment (25%):', paddingAdjustment);
    debugLog('Wrapper Padding Top:', paddingTop);
    debugLog('Wrapper Padding Bottom:', paddingBottom);
    debugLog('Total Wrapper Padding:', totalPadding);
    debugLog('Available Height:', availableHeight);
    debugLog('Final Height:', finalHeight);

    // Apply the calculated height to the centres list
    centresList.style.height = `${finalHeight}px`;
  }
}

//////////////////////////////////////////////////////////////////////////////
// Create a marker for a centre
// This function creates a map marker for a given centre, adds it to the map,
// and includes it in the list of centres.
//////////////////////////////////////////////////////////////////////////////
function createMarker(centre, infoWindow, bounds) {
  // Create a LatLng object for the centre's position
  const position = new google.maps.LatLng(centre.lat, centre.lng);

  // Extend the map bounds to include the new position
  bounds.extend(position);

  // Create the marker object
  const marker = new google.maps.Marker({
    position: position, // Set the position of the marker
    map: isProjectsPage ? null : map, // Associate the marker with the map
    title: centre.title, // Set the title of the marker
    icon: {
      url: mapConfig.icons.inactive, // URL for the marker icon
      scaledSize: new google.maps.Size(marker_x_size, marker_y_size), // Size of the inactive icon
      anchor: new google.maps.Point(marker_x_center, marker_y_center)
    }
  });


  // Store the centre ID in the marker for reference
  marker.centreId = centre.id;

  // Add a click listener to the marker to handle activation and scrolling
  marker.addListener('click', () => {
    setActiveMarker(marker); // Highlight the marker when clicked

    if (jQuery(window).width() < 992) {
        jQuery('html, body').animate({scrollTop: jQuery('.centres-listing-wrapper').offset().top - 90}, 0, function() {
          scrollToListItem(centre.id); // Scroll to the list item when the marker is clicked
        });
    } else {
        scrollToListItem(centre.id); // Scroll to the list item when the marker is clicked
    }

  });

  // Store the marker in the centre object for future reference
  centre.marker = marker;

  // Clustering - push
  markersObject.push(marker);

  // Add the centre to the list of centres
  addCentreToList(centre, marker);
}

//////////////////////////////////////////////////////////////////////////////
// CLUSTERING FUNCTIONS
//////////////////////////////////////////////////////////////////////////////
function createMarkerClustering(){
  if (!mapConfig.clustering?.enabled || !isProjectsPage) return;

  markerClusterer = new MarkerClusterer(null, [], {
    gridSize: 40,
    maxZoom: 14,
    zoomOnClick: false,

    styles: [{
      url: '/wp-content/themes/bryantbuildingcontractors/assets/img/map-cluster.svg',
      height: 50,
      width: 50,
      textColor: "#ffffff",
      textSize: 14,
      anchorText: [0, 0]
    }]
  });

  google.maps.event.addListener(markerClusterer, 'clusterclick', function(cluster) {
    smoothZoomToCluster(cluster);
  });

  setTimeout(() => {
    markerClusterer.addMarkers(markersObject);
    markerClusterer.setMap(map);
  }, 200);
}

function smoothZoomToCluster(cluster) {
  const center = cluster.getCenter();
  let targetZoom = Math.min(map.getZoom() + 2, 16);

  

  isClusterZooming = true; // START LOCK

  map.panTo(center);

  smoothZoom(map, targetZoom, () => {
    // apply different offset per breakpoint
    adjustMapCenter(isMobile ? -8 : 4);

    isClusterZooming = false; // RELEASE LOCK
  });
}

function smoothZoom(map, targetZoom, callback) {
  let currentZoom = map.getZoom();
  function zoomStep() {
    if (currentZoom >= targetZoom) {
      if (callback) callback();
      return;
    }
    currentZoom++;
    map.setZoom(currentZoom - .5);
    setTimeout(zoomStep, 12); // speed control (lower = faster)
  }
  zoomStep();
}

function refreshMarkerClustering(){
  if (!markerClusterer || !isProjectsPage) return;

  markerClusterer.clearMarkers();
  markerClusterer.addMarkers(markersObject);
}

function clearAllMarkers() {
  markersObject.forEach(marker => marker.setMap(null));
  markersObject = [];

  if (mapConfig.clustering?.enabled && markerClusterer) {
    markerClusterer.clearMarkers();
  }

  mapData.centres.forEach(centre => {
    centre.marker = null;
  });
}

let debugBoundsOverlay = null;

function drawBoundsOverlay() {
  const bounds = map.getBounds();
  if (!bounds) return;

  // Remove previous overlay
  if (debugBoundsOverlay) {
    debugBoundsOverlay.setMap(null);
  }

  // Create new overlay
  debugBoundsOverlay = new google.maps.Rectangle({
    bounds: bounds,
    strokeColor: "#007BFF",   // blue border
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#007BFF",     // blue fill
    fillOpacity: 0.15,        // translucent
    map: map
  });
}




//////////////////////////////////////////////////////////////////////////////
// Add a centre to the list
// This function creates a list item for a centre and appends it to the list
// of centres. It also sets up event listeners for interactions with the list item.
//////////////////////////////////////////////////////////////////////////////
function addCentreToList(centre, marker) {
  // Create the list item element
  const listItem = document.createElement('a');
  listItem.href = centre.link ; // Set default href
  listItem.className = 'list-group-item list-group-item-action responsive-rounded mb-0'; // Set class for styling
  listItem.dataset.centreId = centre.id; // Store the centre ID in a data attribute

  // Set the inner HTML of the list item with centre details and action buttons
  if(centre.type == 'office'){
    listItem.innerHTML = `
      <div class="row g-3">
        <div class="col-lg-12">
          <h4>${centre.title}</h4>
          <p class="centres-office-emmergency-first mb-0">
              Emergency call: <span data-href="tel:${centre.office_emergency1}" class="centres-office-phone js-centres-office-phone hover-underline">${centre.office_emergency1}</span>
              ${centre.office_emergency2 ? ' or <span data-href="tel:'+centre.office_emergency2+'" class="centres-office-phone js-centres-office-phone hover-underline">' + centre.office_emergency2 + '</span>' : ''}
            </p>
          <p data-href="tel:${centre.office_phone}" class="centres-office-phone js-centres-office-phone mb-0 text-decoration-none hover-underline">${centre.office_phone}</p>
          <p data-href="mailto:${centre.office_email}" class="centres-office-email js-centres-office-email mb-0 text-decoration-none hover-underline">${centre.office_email}</p>
          <p class="centres-office-address mb-0">${centre.office_address}</p>
          <p data-href="https://www.google.com/maps/dir/?api=1&destination=${centre.lat},${centre.lng}" target="_blank" class="centres-office-directions d-inline-flex flex-row align-items-center text-body js-directions-link mb-0">
            <span class="js-directions-link">Directions</span>
            <i class="icon icon-arrow-forward js-directions-link"></i>
          </p>
        </div>
      </div>`
  }else{ //projects
    listItem.innerHTML = `
      <div class="row g-3">
        <div class="col-lg-12">
          <h4 class="proj">${centre.title}</h4>
          <p class="centres-project-description" class="mb-0">${centre.excerpt}</p>
        </div>
        <div class="col-lg-12 mt-0">
          <div class="d-inline-flex gap-3">
            <button class="btn btn-primary js-view-centre" data-href="${centre.link}">View the Project</button>
          </div>
        </div>
      </div>`;
  };

  if (mapConfig.persistActive && activeCentreId && centre.id == activeCentreId) {
    listItem.classList.add('active');
  }

  // Add click event listener to the list itemmywaitlist-form
  listItem.addEventListener('click', (event) => {
    const target = event.target;

    // Handle directions link
    if (target.classList.contains('js-directions-link')) {
      event.preventDefault();
      const link = event.target.closest('.js-directions-link');
      const url = link.closest('.centres-office-directions').dataset.href;
      window.open(url, '_blank');
      return; // Allow default action for directions link
    }

    // Handle view centre button
    if (target.classList.contains('js-view-centre')) {
      event.preventDefault();
      window.location.href = target.getAttribute('data-href');
      return;
    }

    //Handle telephone link
    if (target.classList.contains('js-centres-office-phone')) {
      event.preventDefault();
      window.location.href = target.getAttribute('data-href');
      return;
    }

    //Handle email link
    if (target.classList.contains('js-centres-office-email')) {
      event.preventDefault();
      window.location.href = target.getAttribute('data-href');
      return;
    }

    // Handle book tour button
    if (target.classList.contains('js-book-tour')) {
      event.preventDefault();
      window.location.href = target.getAttribute('data-href');
      return;
    }

    // Handle clicking on the list item itself
    event.preventDefault();
    setActiveMarker(marker); // Highlight the marker and list item when clicked
  });

  // Append the list item to the centres list
  document.querySelector('.js-centres-list').appendChild(listItem);
}

//////////////////////////////////////////////////////////////////////////////
// Scroll to the list item corresponding to the centre ID
// This function scrolls the centres list to bring the specified centre's list
// item into view and highlights it by adding an active class.
//////////////////////////////////////////////////////////////////////////////
function scrollToListItem(centreId) {
  // Select the list item corresponding to the centre ID
  const listItem = document.querySelector(`.js-centres-list a[data-centre-id="${centreId}"]`);
  if (listItem) {
    // Add active class to the clicked list item
    listItem.classList.add('active');

    // Select the centres list container
    const centresList = document.querySelector('.js-centres-list');

    // Scroll the list container so that the list item is at the top
    centresList.scrollTop = listItem.offsetTop - centresList.offsetTop;
  }
}

//////////////////////////////////////////////////////////////////////////////
// Update the centres list in the DOM
// This function updates the list of centres displayed on the page by clearing
// the existing list and then adding the provided centres to the list.
//////////////////////////////////////////////////////////////////////////////
function updateCentreList(centres) {
  // Get the reference to the centres list element
  const centresList = document.querySelector('.js-centres-list');

  // Clear existing list of centres
  centresList.innerHTML = '';

  // Iterate through each centre and add it to the list
  centres.forEach(centre => {
    addCentreToList(centre, centre.marker);
  });
}

//////////////////////////////////////////////////////////////////////////////
// Scroll to the map section
//////////////////////////////////////////////////////////////////////////////
function scrollToMapSection() {
  // Select the map section and sticky element
  const mapSection = document.querySelector('.js-section-centres-map');
  const stickyElement = document.querySelector('.js-sticky-top');

  // Proceed if the map section exists
  if (mapSection) {
    // Calculate the height of the sticky element, if it exists
    const stickyHeight = stickyElement ? stickyElement.offsetHeight : 0;
    // Additional offset to account for extra spacing
    const additionalOffset = 60;
    // Calculate the top position of the map section, accounting for sticky height and additional offset
    // const mapSectionTop = mapSection.getBoundingClientRect().top + window.scrollY - stickyHeight - additionalOffset;
    const mapSectionTop = mapSection.getBoundingClientRect().top + window.scrollY - additionalOffset;

    // Smoothly scroll to the calculated top position
    window.scrollTo({
      top: mapSectionTop,
      behavior: 'smooth'
    });
  }
}

//////////////////////////////////////////////////////////////////////////////
// Adjust the map center to fit the specified half of the map based on breakpoints
//////////////////////////////////////////////////////////////////////////////
function adjustMapCenter(customOffsetDivisor = null, customZoom = null) {
  const bounds = map.getBounds();

  if (bounds) {
    //const center = bounds.getCenter();
    const center = map.getCenter();
    const span = bounds.toSpan();

    let newCenter = {
      lat: center.lat(),
      lng: center.lng()
    };

    if (isMobile) {
      // 🎯 Mobile behavior

      // Horizontal → center (no change)
      newCenter.lng = center.lng();

      const offsetDivisorMobile = customOffsetDivisor || 4;

      // Vertical → shift downward (towards bottom 75%)
      newCenter.lat = center.lat() - (span.lat() / offsetDivisorMobile);

    } else {
      // 🎯 Desktop behavior (your existing logic)

      const shouldOffset = mapConfig.enableOffset && shouldEnableOffset();
      const offsetDirection = mapConfig.offsetDirection === 'left' ? 1 : -1;

      const offsetDivisor = customOffsetDivisor || 6;

      newCenter.lng = shouldOffset
        ? center.lng() + offsetDirection * (span.lng() / offsetDivisor)
        : center.lng();

      // keep vertical centered
      newCenter.lat = center.lat();
    }

    map.setCenter(newCenter);

    if (customZoom !== null) {
      map.setZoom(customZoom);
    }

  } else {
    setTimeout(() => adjustMapCenter(customOffsetDivisor, customZoom), 100);
  }
}

//////////////////////////////////////////////////////////////////////////////
// Determine if offset should be enabled based on screen width and breakpoints
// This function checks the current screen width against the defined breakpoints
// in the mapConfig to decide if the map offset should be enabled.
//////////////////////////////////////////////////////////////////////////////
function shouldEnableOffset() {
  const screenWidth = window.innerWidth;

  // Check breakpoints in descending order to apply the correct rule
  const breakpoints = Object.keys(mapConfig.mediaQueryBreakpoints).sort((a, b) => b - a);

  for (const breakpoint of breakpoints) {
    if (screenWidth >= breakpoint) {
      return mapConfig.mediaQueryBreakpoints[breakpoint];
    }
  }

  // If screen width is less than the smallest breakpoint, return false
  return false;
}

//////////////////////////////////////////////////////////////////////////////
// Create a debug pin for visualisation
// This function creates a debug pin at a given position on the map using the
// specified icon URL. It adds the debug pin to the map and stores a reference
// to the debug pin in the debugPins array for future manipulation.
//////////////////////////////////////////////////////////////////////////////
function createDebugPin(position, iconUrl) {
  // Create a new marker for the debug pin
  const debugPin = new google.maps.Marker({
    position: position, // Set the position of the debug pin
    map: map, // Associate the debug pin with the map
    icon: {
      url: iconUrl, // URL for the debug pin icon
      scaledSize: new google.maps.Size(30, 30), // Adjust size of the debug pin icon
      anchor: new google.maps.Point(marker_x_center, marker_y_center)
    }
  });
  // Store reference to the debug pin in the debugPins array
  debugPins.push(debugPin);
}

//////////////////////////////////////////////////////////////////////////////
// Clear debug pins
// This function iterates over all debug pins stored in the debugPins array
// and removes them from the map. It then clears the debugPins array to
// reset the stored references.
//////////////////////////////////////////////////////////////////////////////
function clearDebugPins() {
  // Iterate over all debug pins and remove them from the map
  debugPins.forEach(pin => pin.setMap(null));
  // Reset the debugPins array after clearing the pins
  debugPins = [];
}
